import {Component, Input, OnInit} from '@angular/core';
import {ReportFilter} from '../../../models/dealers/dealer-filter.model';
import {HttpService} from '../../../services/http.service';
import {DealerData} from '../../../models/Report/dealerData.modal';


@Component({
  selector: 'app-invoice-summary',
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.scss']
})
export class InvoiceSummaryComponent implements OnInit {
  filter: ReportFilter = new ReportFilter();
  dealerData: DealerData = new DealerData();
  searchText = '';
  total = 0;
  @Input() dealerName: any[] = [];

  constructor(private http: HttpService) {
  }

  ngOnInit(): void {
    this.refreshList();
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  refreshList() {
    if (this.filter.dealerNumber === 'null') {
      this.filter.dealerNumber = null;
    }
    this.http.getInvoice(this.filter).subscribe((res: DealerData) => {
      this.dealerData = Object.assign(new DealerData(), res);
    });
  }

  sum(total1, total2) {
    return total1 + total2;
  }

  exportAsXLSX(dealer) {
    const data = {
      dealerNumber: dealer.dealerNumber,
      invoicedDate: dealer.invoicedDate
    };
    this.http.downloadDealerReport(data);
  }


  amount(invoice: any): string {
    const amount = invoice.total;
    return `EUR ${amount}`;
  }

  showDirectionImage(): string {
    if (this.filter.orderBy === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  clearFilter() {
    this.filter = new ReportFilter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }
}
